import TextField from "@material-ui/core/TextField";
import { TrendingUp, AttachMoney } from "@material-ui/icons";
import React from "react";
import styled, { keyframes } from "styled-components";

function TabVolumetria({ values, touched, errors, handleChange, formik }) {
	return (
		<ModernFormContainer>
			<SectionCard>
				<SectionHeader>
					<SectionIcon color="#27ae60">
						<TrendingUp />
					</SectionIcon>
					<SectionTitle>Volumetria e Provisionamento</SectionTitle>
				</SectionHeader>
				<StyledFieldContainer>
					<FieldLabel>
						<AttachMoney style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
						Total Provisionado / MÊS
					</FieldLabel>
					<TextField
						InputLabelProps={{ shrink: true }}
						fullWidth
						id="provisioned"
						name="provisioned"
						placeholder="Digite o valor provisionado mensal"
						value={values["provisioned"]}
						onChange={handleChange}
						error={touched.provisioned && Boolean(errors.provisioned)}
						helperText={touched.provisioned && errors.provisioned}
						autoComplete="off"
						variant="outlined"
					/>
				</StyledFieldContainer>
			</SectionCard>
		</ModernFormContainer>
	);
}

export default TabVolumetria;

// Animações
const fadeIn = keyframes`
	from {
		opacity: 0;
		transform: translateY(10px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;

const ModernFormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
	background: white;
	border-radius: 16px;
	padding: 24px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
	border: 1px solid #e8e8e8;
	animation: ${fadeIn} 0.5s ease;
	transition: all 0.3s ease;

	&:hover {
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		border-color: #d0d0d0;
	}
`;

const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	padding-bottom: 16px;
	border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${props => props.color ? `${props.color}15` : '#667eea15'};
	color: ${props => props.color || '#667eea'};
	margin-right: 12px;
	transition: all 0.3s ease;

	svg {
		font-size: 22px;
	}

	${SectionCard}:hover & {
		transform: scale(1.1);
	}
`;

const SectionTitle = styled.h3`
	font-size: 18px;
	font-weight: 700;
	color: #2c3e50;
	margin: 0;
	font-family: 'Mulish', sans-serif;
`;

const StyledFieldContainer = styled.div`
	display: flex;
	flex-direction: column;

	.MuiOutlinedInput-root {
		border-radius: 10px;
		transition: all 0.3s ease;

		&:hover {
			box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
		}

		&.Mui-focused {
			box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
		}
	}

	.MuiInputLabel-outlined {
		font-family: 'Mulish', sans-serif;
		font-weight: 500;
	}

	.MuiOutlinedInput-input {
		font-family: 'Mulish', sans-serif;
	}
`;

const FieldLabel = styled.label`
	font-size: 14px;
	font-weight: 600;
	color: #2c3e50;
	margin-bottom: 8px;
	display: flex;
	align-items: center;
	font-family: 'Mulish', sans-serif;
`;
